import { Button, Stack, Typography } from '@common-components';
import { EmailOutlined } from '@icons';
import { messages } from 'i18n';
import { RouteKey } from 'broker/enums';
import { useNavigate } from 'broker/hooks';
import { useWorkspaceUrls } from 'broker/pages/SubmissionWorkspacePage/hooks';

export default function SendSolicitationBanner() {
  const { sendSolicitationBanner } = messages.submissionWorkspace;
  const navigate = useNavigate();
  const { solicitationUrl } = useWorkspaceUrls();

  const handleSendSolicitation = () => {
    navigate(solicitationUrl, {
      routeKey: RouteKey.Solicitation,
      state: undefined,
    });
  };

  return (
    <Stack direction="row" gap={1} my={1} py={1} px={1.5} alignItems="center" bgcolor="warning.light">
      <Stack direction="row" alignItems="flex-start" flex={1}>
        <Stack overflow="hidden">
          <Typography noWrap variant="body2Bold" color="text.primary">
            {sendSolicitationBanner.title}
          </Typography>
          <Typography variant="caption" color="text.primary">
            {sendSolicitationBanner.description}
          </Typography>
        </Stack>
      </Stack>
      <Button
        size="medium"
        color="inherit"
        variant="outlined"
        startIcon={<EmailOutlined />}
        onClick={handleSendSolicitation}
      >
        {sendSolicitationBanner.button}
      </Button>
    </Stack>
  );
}
